module.exports = __webpack_public_path__ + "static/bg-welcome-cd743d3b9c00ac3f5e878ba8b268b9fe.jpg";